<template>
  <a-modal
    width="70%"
    :title="$t('global.broadcast')"
    v-model="visable"
    centered
    @ok="handleOk"
    @cancel="quit"
    destroyOnClose
    :zIndex="1005" >
    <div slot="footer">
      <a-button @click="quit">{{$t('global.close') }}</a-button>
    </div>
    <a-tabs defaultActiveKey="broadcast">
      <a-tab-pane key="broadcast" :tab="$t('global.broadcast')">
        <div class="box">
          <div class="tree">
            <a-tree
              checkable
              :autoExpandParent="true"
              @check="onSelect"
              :treeData="broadcastTree"
            />
          </div>
          <div class="editor">
            <div class="title">
              <label>{{$t('global.receiver')}}:</label>
              <span>{{receivers.join(',')  }}</span>
            </div>
            <div class="edit">
              <!-- <a-input v-model="content"></a-input> -->
              <a-textarea
                :placeholder="$t('global.broadcastTip')"
                :autosize="{ minRows: 2, maxRows: 6 }"
                v-model="content"
              />
              <!-- <Editor v-model="content" /> -->
            </div>

            <div v-if="showErrorText" class="error">
              {{errorMsg}}
            </div>
            <!-- {{broadcastTree}} -->
            <div class="send">
             {{$t('global.broadcastCount')}}: <a-input-number v-model="broadcastCount" :min="1" :max="10" :step="1" :placeholder="$t('global.broadcastCount')" style="margin-right: 10px;"></a-input-number>
              {{$t('global.broadcastInterval')}}: <a-input-number v-model="broadcastInterval" :min="3" :max="10" :step="1" :placeholder="$t('global.broadcastInterval')" style="margin-right: 10px;"></a-input-number>
              
              <a-button :disabled="showErrorText || !content || selectedUsers.length === 0" type="primary" @click="handleOk">
                {{ $t('global.send') }}
              </a-button>
            </div>
          </div>
        </div>
      </a-tab-pane>

      <a-tab-pane key="list" :tab="$t('global.broadcastList')">
        <List />
      </a-tab-pane>
    </a-tabs>
    
  </a-modal>
</template>
<script>
import {mapState, mapGetters, mapActions} from 'vuex'
import config from '../../config'
export default {
  components: {
    // Editor: () => import('./Editor'),
    List: () => import('./BroadcastList')
  },
  data () {
    return {
      visable: false,
      selectedUsers: [],
      allUser: '',
      receivers: [],
      editor: '',
      content: '',
      errorMsg: '',
      showErrorText: false,
      broadcastCount: 3,
      broadcastInterval:5
    }
  },
  computed: {
    ...mapState({
      tree: state => state.home.orgTreeData
    }),
    ...mapGetters(['broadcastTree'])
  },
  watch: {
    content (newV, oldV) {
      console.log(newV)
      if (newV !== oldV) {
        let regCn = /[~！@#￥%……&*？[\]{}']/im
        if (newV.length > 67) {
          this.showError('请控制长度在67个字符以为')
        } else if (regCn.test(newV)) {
          this.showError('请不要使用特殊字符')
        } else {
          this.clearError()
        }
      }
    }
  },
  methods: {
    ...mapActions(['initOrgTree']),
    // 显示输入错误
    showError (errMsg) {
      this.errorMsg = errMsg
      this.showErrorText = true
    },
    clearError () {
      this.errorMsg = ''
      this.showErrorText = false
    },
    handleOk () {
      // 判断是否有接收者和内容
      if (this.selectedUsers.length === 0 || !this.content) {
        this.$message.error('内容为空或没有接收人')
      } else {
        let param = {
          entityIds: this.selectedUsers,
          // commandId: '?',
          content: this.content.replace(/<[^>]+>/g, ''),
          count: this.broadcastCount,
          interval: this.broadcastInterval
        }
        console.log(param)
        this.$http.post(config.api.broadcast_message, param).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success(this.$t('home.sendCommandSuccess'))
            this.content = ''
            this.receivers = []
            this.visable = false
            this.broadcastCount = 3
            this.broadcastInterval = 5
          } else {
            this.$notification.error({
              message: res.desc
            })
          }
        })
      }
      // 发送信息
      // this.visable = false
    },
    quit () {
      this.visable = false
    },
    onSelect (ev) {
      // console.log(this.broadcastTree)
      // 筛选出实体IDS
      let userIds = ev.filter((i) => {
        return !i.includes('-')
      })
      this.selectedUsers = userIds
      // 筛选出所有实体姓名
      const treeToArray = (tree) => {
        let users = []
        tree.forEach((leaf) => {
          if (leaf.children) {
            let u = treeToArray(leaf.children)
            users.push(u)
          } else {
            users.push(leaf)
          }
        })
        return users
      }
      // console.log(treeToArray(this.broadcastTree).flat(Infinity))
      this.allUser = treeToArray(this.broadcastTree).flat(Infinity)
      // 筛选出要发送消息的人名
      let receivers = userIds.map((id) => {
        return this.allUser.find((user) => user.key == id).title
      })
      console.log(receivers)
      this.receivers = receivers
    },
  },
  created () {
    // 若此时orgtree为空值则需要去请求人员和机构树来合并数据，此时点开广播页面因没有机构人员导致无法选择
    // 次情况会发生于用户于非首页 刷新页面的情况下
    if (this.tree.length === 0) {
      this.initOrgTree()
    }
  }
}
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  height: 600px;
  display: grid;
  // justify-content: space-around;
  grid-template-columns: 300px auto;
  .tree {
    // width: 300px;
    border-right: 1px solid #eee; 
    max-height: 600px;
    overflow-y: auto;
  }
  .editor {
    // width: 100vw;
    background: #eee;
    margin: 0;
    padding:  20px;
    .title {
      // width: 100vw;
      border-bottom: 1px solid #ccc;
      padding: 5px;
      background: #fff;
      margin-bottom: 20px;
      border-radius: 5px; 
    }
    .error {
      // width: 100vw;
      margin-top: 5px; 
      // margin-bottom: 20px;
      color: red;
    }
    .send {
      margin-top: 20px; 
    }
  }
}
</style>